import React from "react";
import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import Input from "../../../../form/Input";
import Textarea from "../../../../form/Textarea";
import Button from "../../../../form/Button";
import Image from "../../../../elements/Image";
import ButtonFile from "../../../../form/ButtonFile";
import useForm from "../../../../../hooks/useForm";

const SettingsDetails = () => {
  const { theme, selectedElement, status, colors, appliedTheme } = useSelector(
    (state) => state?.themeProvider
  );

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({});

  const { mutate } = useMutation({
    mutationFn: async (val) => {},
  });

  return (
    <div>
      <form onSubmit={(event) => handleSubmit(event, mutate)}>
        <div className="w-full max-w-[100%]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="relative col-span-full">
              <Input
                label="Title"
                inputPlaceholder="Enter Title"
                inputName="title"
                value={values?.title}
                onChange={handleChange}
                {...formValidate(errors, "title")}
              />
            </div>
            <div className="relative col-span-full">
              <Input
                label="Address"
                inputPlaceholder="Enter Address"
                inputName="address"
                value={values?.address}
                onChange={handleChange}
                {...formValidate(errors, "address")}
              />
            </div>
            <div className="relative">
              <Input
                label="Office Hours"
                inputPlaceholder="Enter Date and Time"
                inputName="officeHours"
                value={values?.officeHours}
                onChange={handleChange}
                {...formValidate(errors, "officeHours")}
              />
            </div>
            <div className="relative">
              <Input
                label="Email"
                inputPlaceholder="Enter Email"
                inputName="email"
                value={values?.email}
                onChange={handleChange}
                {...formValidate(errors, "email")}
              />
            </div>
            <div className="relative col-span-full">
              <Input
                label="Footer Title"
                inputPlaceholder="Enter Footer Title"
                inputName="footerTitle"
                value={values?.footerTitle}
                onChange={handleChange}
                {...formValidate(errors, "footerTitle")}
              />
            </div>
            <div className="relative col-span-full">
              <Textarea
                label="Footer Description"
                inputPlaceholder="Enter Footer Description"
                inputName="description"
                inputValue={values?.description}
                onChange={handleChange}
                {...formValidate(errors, "description")}
              />
            </div>
          </div>

          {/* Social Media Links */}
          <div className="relative space-y-3">
            <div className="font-CanelaDeck font-medium pb-2 border-b border-shades-04">
              Social Media Links
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {values?.social?.map((platform, index) => (
                <div key={index} className="flex items-center">
                  {platform?.icon && (
                    <div className="w-[50px] aspect-square flex items-center justify-center mt-5 border border-shades-05/50 rounded-l-md -mr-1">
                      <i className={`${platform?.icon}`}></i>
                    </div>
                  )}
                  <Input
                    label={platform.name || "Link"}
                    inputName={`social-${index}`}
                    inputPlaceholder={`Enter ${platform.name} link like https://facebook.com/`}
                    inputClasses={platform?.icon ? "!rounded-l-none" : ""}
                    labelClasses={platform?.icon ? "-ml-9" : ""}
                    value={platform?.url}
                    onChange={(e) => {
                      const url = e.target.value;
                      // const { name, icon } = getSocialMediaDetails(url);
                      // const updatedSocial = [...values.social];
                      // updatedSocial[index] = {
                      //   ...updatedSocial[index],
                      //   url,
                      //   name,
                      //   icon,
                      // };
                      // setFieldsValue({ social: updatedSocial });
                      // if (url.trim() !== "") {
                      //   setError((prev) => ({
                      //     ...prev,
                      //     errorIndex: prev.errorIndex?.filter(
                      //       (idx) => idx !== index
                      //     ),
                      //   }));
                      // }
                    }}
                  />
                  <Button
                    type="button"
                    buttonIcon="fa-regular fa-trash"
                    buttonIconPosition="left"
                    buttonClasses="text-white mt-5 mx-3"
                    buttonFunction={() => {
                      const updatedSocial = values.social.filter(
                        (_, idx) => idx !== index
                      );
                      setFieldsValue({ social: updatedSocial || [] });
                    }}
                  />
                </div>
              ))}
            </div>
            <div className="flex">
              <Button
                type="button"
                buttonLabel="Add More"
                variant="secondary"
                buttonFunction={() => {
                  setFieldsValue({
                    social: [...values.social, { name: "", url: "", icon: "" }],
                  });
                }}
              />
            </div>
          </div>

          <div className="flex">
            <Button
              buttonLabel="Save Settings"
              variant="secondary"
              buttonType="submit"
              // {...(isLoad && {
              //   loading: true,
              //   buttonIconPosition: "left",
              //   isDisable: true,
              // })}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default SettingsDetails;
